import React, { useState } from "react"

const SESSION_KEY = "pf_client_auth"

export function ClientGate({ clientId, password, children }) {
  const stored = sessionStorage.getItem(SESSION_KEY + "_" + clientId)
  const [unlocked, setUnlocked] = useState(stored === "1")
  const [input, setInput] = useState("")
  const [error, setError] = useState(false)

  if (unlocked) return children

  const handleSubmit = e => {
    e.preventDefault()
    if (input === password) {
      sessionStorage.setItem(SESSION_KEY + "_" + clientId, "1")
      setUnlocked(true)
    } else {
      setError(true)
      setInput("")
    }
  }

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#000",
      color: "#fff",
      fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    }}>
      <form onSubmit={handleSubmit} style={{ textAlign: "center", maxWidth: 360, width: "100%", padding: "0 24px" }}>
        <p style={{ fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", opacity: 0.4, marginBottom: 40 }}>
          Client Portal
        </p>
        <input
          type="password"
          value={input}
          autoFocus
          placeholder="Enter password"
          onChange={e => { setInput(e.target.value); setError(false) }}
          style={{
            width: "100%",
            background: "transparent",
            border: "none",
            borderBottom: error ? "1px solid #FF4000" : "1px solid rgba(255,255,255,0.2)",
            color: "#fff",
            fontSize: 16,
            padding: "12px 0",
            outline: "none",
            textAlign: "center",
            letterSpacing: "0.1em",
            boxSizing: "border-box",
            transition: "border-color 0.2s",
          }}
        />
        {error && (
          <p style={{ fontSize: 12, color: "#FF4000", marginTop: 12, opacity: 0.9 }}>
            Incorrect password
          </p>
        )}
        <button
          type="submit"
          style={{
            marginTop: 32,
            background: "transparent",
            border: "1px solid rgba(255,255,255,0.2)",
            color: "#fff",
            fontSize: 12,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            padding: "12px 32px",
            cursor: "pointer",
            transition: "border-color 0.2s",
          }}
        >
          Enter
        </button>
      </form>
    </div>
  )
}
